// ── In-app browser detection ──────────────────────────────────────────────────
// Instagram, Facebook/Messenger, and TikTok's built-in link browsers (WebViews
// embedded inside their own apps, opened when a user taps a link in a bio, DM,
// or story) have a known bug: triggering a native OS picker sheet — most
// reliably `<input type="time">` and `<input type="date">`, both used all over
// Clarity's Planner — makes the host app think the user is navigating away, so
// it closes the in-app browser and dumps them back into the feed. It reads to
// the user as "the app randomly closes," but it isn't something the app code
// controls; the fix is steering people to a real browser instead. Detection is
// UA-sniffing only (there's no feature-detection API for "am I inside an
// in-app browser"), so treat `browserName` as best-effort, not authoritative.
function detectInAppBrowser(ua) {
  if (/Instagram/i.test(ua)) return "Instagram";
  if (/FBAN|FBAV|FB_IAB/i.test(ua)) return "Facebook";
  if (/BytedanceWebview|musical_ly|TikTok/i.test(ua)) return "TikTok";
  return null;
}

export function useInAppBrowser() {
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  return { browserName: detectInAppBrowser(ua) };
}
